import React from 'react';
import {FileDetails} from './file-details';
import {DocumentsList} from './documents-list';
import {Collapse, formatPatent} from "presentation/common";
import {HeaderActions} from "./header-actions";

import styles from './styles.module.scss';

export const MobileView = ({detailInfo, documents, onDelete, onDownloadDocuments}) => (
  <>
    <HeaderActions onDownloadDocuments={onDownloadDocuments}/>
    <div className={styles.mobileContainer}>
      <h3 className={styles.mobileContainerTitle}>Vehículo: {formatPatent(detailInfo?.vehiculo?.patente)}</h3>

      <Collapse title="DATOS GENERALES">
        <FileDetails detailInfo={detailInfo}/>
      </Collapse>

      <Collapse title={`DOCUMENTOS (${documents?.length || 0})`}>
        <DocumentsList documents={documents} onDelete={onDelete}/>
      </Collapse>
    </div>
  </>
);
